export interface SafeStorage {
  get(key: string): string | null;
  set(key: string, value: string): void;
}

export const safeStorage: SafeStorage = {
  get(key) {
    try {
      return window.localStorage?.getItem(key) ?? null;
    } catch {
      return null;
    }
  },
  set(key, value) {
    try {
      window.localStorage?.setItem(key, value);
    } catch {
      /* sandboxed; ignore */
    }
  },
};
